import { Brand, Environment, NodeEnvironment } from './envConfig'
import { getEnvironmentValue as getValue } from './envUtil'

const nodeEnv = getValue(process.env, 'NODE_ENV', NodeEnvironment) as NodeEnvironment;

export default {
    ENVIRONMENT: getValue(process.env, 'REACT_APP_ENVIRONMENT', Environment) as Environment,
    NODE_ENV: nodeEnv,
    BRAND: getValue(process.env, 'REACT_APP_BRAND', Brand) as Brand,
    ENDPOINT_HOST: getValue(process.env, 'REACT_APP_ENDPOINT_HOST'),
    BRAND_STYLE: getValue(process.env, 'REACT_APP_BRAND_STYLE'),
    ERROR_REDIRECT: getValue(process.env, 'REACT_APP_ERROR_REDIRECT'),
    CONTACT_EMAIL: getValue(process.env, 'REACT_APP_CONTACT_EMAIL'),
    CONTACT_PHONE: getValue(process.env, 'REACT_APP_CONTACT_PHONE'),
    CONTACT_PHONE_READABLE: getValue(process.env, 'REACT_APP_CONTACT_PHONE_READABLE'),
    CONTACT_LINKED_IN: getValue(process.env, 'REACT_APP_CONTACT_LINKED_IN'),
    
    DEBUG_UNBLOCK_ROUTES: false || (nodeEnv === 'development'),
    DEBUG_SUPPRESS_ERROR_ALERTS: false && (nodeEnv === 'development'),
    DEBUG_SUPPRESS_UNLOAD_WARNING: false && (nodeEnv === 'development'),
}
